// extracted by mini-css-extract-plugin
export default {"enterEmailWrapper":"EnterNewEmailStep_enterEmailWrapper__KKvYV","formWrapper":"EnterNewEmailStep_formWrapper__8xAz3","formTitle":"EnterNewEmailStep_formTitle__p62co"};